"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var TokenRenderers_1 = require("./TokenRenderers");
var CommonWidgetRegistry_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgetRegistry");
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var dynamic_1 = require("@vanilla-extract/dynamic");
var tokenRenderer = function (tokens, options) {
    var html = "";
    if (!tokens || !tokens.length) {
        return html;
    }
    var currentBlock = null;
    var innerHtml = "";
    var currentIndex = 0;
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        if (token.type == "block") {
            if (currentBlock != undefined) {
                html += renderBlock(currentBlock, currentIndex, tokens, innerHtml, options);
                innerHtml = "";
            }
            currentBlock = token;
            currentIndex = i;
        }
        else if (token.type == "inline") {
            innerHtml += renderInlineToken(token);
        }
    }
    html += renderBlock(currentBlock, currentIndex, tokens, innerHtml, options);
    return html;
};
var makeStylableAttributes = function (token, options) {
    var e_1, _a;
    var _b, _c, _d, _e, _f;
    var styleableConfig = (0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: token.subType, traitName: "styleable" });
    if (styleableConfig) {
        var style = {};
        try {
            for (var _g = __values(styleableConfig.properties), _h = _g.next(); !_h.done; _h = _g.next()) {
                var property = _h.value;
                if (!property.var)
                    continue;
                if (property.type === "color") {
                    var styleColor = (_d = (_c = (_b = options === null || options === void 0 ? void 0 : options.blockStyles) === null || _b === void 0 ? void 0 : _b[styleableConfig.styleKey]) === null || _c === void 0 ? void 0 : _c[property.name]) !== null && _d !== void 0 ? _d : {
                        themeIndex: 0,
                    };
                    style[property.var] = (_f = (0, GetBlockStyle_1.sanitizeColor)(styleColor, (_e = options.brandColors) !== null && _e !== void 0 ? _e : [])) === null || _f === void 0 ? void 0 : _f.value;
                }
                else {
                    throw new Error("Unsupported property type");
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return { style: (0, dynamic_1.assignInlineVars)(style) };
    }
};
var renderBlock = function (token, index, tokens, innerHtml, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var registryRenderer = (_a = (0, CommonWidgetRegistry_1.getGenericConfigByType)(token.subType)) === null || _a === void 0 ? void 0 : _a.publicRender;
    if (registryRenderer) {
        var attributes = __assign({}, makeStylableAttributes(token, options));
        return registryRenderer({
            token: token,
            attributes: attributes,
            renderTokens: (_b = options.renderTokens) !== null && _b !== void 0 ? _b : (function () { return ""; }),
        });
    }
    var renderer = TokenRenderers_1.tokenToCreateHtml.get(token.subType);
    if (!renderer) {
        throw new Error("Got an unknown block token subType: ".concat(token.subType));
    }
    return renderer(token, __assign(__assign({}, options), { index: index, innerHtml: innerHtml, tokens: tokens, renderTokens: tokenRenderer }));
};
var renderInlineToken = function (token) {
    var renderer = TokenRenderers_1.tokenToCreateHtml.get(token.subType);
    if (!renderer) {
        throw new Error("Got an unknown inline token subType: ".concat(token.subType));
    }
    return renderer(token, {
        renderTokens: tokenRenderer,
    });
};
exports.default = tokenRenderer;
